// Landing + marketing pages (SITE agent). Plain JS, no dependencies.
//
//   [data-name-demo]   the hero's "Wie heißt dein Kind?": every [data-name-title] (a book title with
//                      data-template="{name} und die Sternenreise") and [data-name] follows the input,
//                      and [data-name-link] links get ?name=... for the wizard; inside a
//                      [data-name-form] (GET to the wizard) Enter submits it.
//   [data-cycle="ms"]  cross-fades its children (.is-current) and writes data-label into [data-cycle-label].
//   [data-reveal]      fades in when scrolled into view.
(function () {
  document.documentElement.classList.add('js');

  // --- the name demo -----------------------------------------------------------------
  document.querySelectorAll('[data-name-demo]').forEach(function (input) {
    var fallback = input.getAttribute('placeholder') || 'Lina';
    function apply() {
      var name = input.value.trim().replace(/\s+/g, ' ').slice(0, 24);
      var shown = name || fallback;
      document.querySelectorAll('[data-name-title]').forEach(function (el) {
        el.textContent = el.getAttribute('data-template').replace('{name}', shown);
      });
      document.querySelectorAll('[data-name]').forEach(function (el) { el.textContent = shown; });
      document.querySelectorAll('[data-name-link]').forEach(function (a) {
        var url = new URL(a.getAttribute('href'), window.location.href);
        if (name) url.searchParams.set('name', name); else url.searchParams.delete('name');
        a.setAttribute('href', url.pathname + url.search);
      });
    }
    input.addEventListener('input', apply);
    if (input.value) apply();
    // [data-name-form]: a GET form to the wizard (Enter works); an empty name sends no ?name=
    var nameForm = input.closest('[data-name-form]');
    if (nameForm) nameForm.addEventListener('submit', function () {
      input.value = input.value.trim().replace(/\s+/g, ' ').slice(0, 24);
      if (!input.value) input.disabled = true;
      setTimeout(function () { input.disabled = false; }, 0);
    });
  });

  // --- cross-fading groups ---------------------------------------------------------------
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-cycle]').forEach(function (group) {
    var items = Array.prototype.slice.call(group.children);
    var label = document.querySelector(group.getAttribute('data-cycle-label') || '[data-none]');
    if (items.length < 2 || reduced) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-current');
      i = (i + 1) % items.length;
      items[i].classList.add('is-current');
      if (label) label.textContent = items[i].getAttribute('data-label') || '';
    }, parseInt(group.getAttribute('data-cycle'), 10) || 3600);
  });

  // --- reveal on scroll -----------------------------------------------------------------
  var revealed = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window)) {
    revealed.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  revealed.forEach(function (el) { io.observe(el); });
})();
